import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer>
      <p className="copyright">
        Developed by Moloko Mokubedi with React ⚛️. Inspired by Matthew Jigalin and Julian Cesaro. 
      </p>
    </footer>
  )
}

export default Footer
